export const disclaimerTranslations: Record<
    string,
    { title: string; text: string }
> = {
    en: {
        title: "DISCLAIMER",
        text: `The Al-assisted summaries are based on uploaded audio/video and may contain errors due to input quality or language variation.
         Please verify the content before official use. The Ministry of Panchayati Raj is not liable for any discrepancies.`
    },
      hi: {
        title: "डिस्क्लेमर",
        text: `ए. आई. निर्मित सारांश अपलोड किए गए ऑडियो/वीडियो पर आधारित हैं और इनपुट क्वालिटी या
            भाषा में बदलाव की वजह से उनमें गलतियाँ हो सकती हैं। ऑफिशियल इस्तेमाल से पहले कृपया कंटेंट
            को वेरिफाई कर लें। पंचायती राज मंत्रालय किसी भी गड़बड़ी के लिए ज़िम्मेदार नहीं है।`
    },

    bn: {
        title: "ডিসক্লেইমার",
        text: `কৃত্রিম বুদ্ধিমত্তা দ্বারা তৈরি সারাংশগুলি আপলোড করা অডিও/ভিডিওর উপর ভিত্তি করে
                তৈরি এবং ইনপুট মান বা ভাষার তারতম্যের কারণে ত্রুটি থাকতে পারে। অফিসিয়াল ব্যবহারের
                আগে অনুগ্রহ করে বিষয়বস্তুটি যাচাই করুন। কোনও অসঙ্গতির জন্য পঞ্চায়েতি রাজ
                মন্ত্রণালয় দায়ী থাকবে না।`
    },

    // bho: {
    //     title: "डिस्क्लेमर",
    //     text: `एआई से बनल सारांश अपलोड कइल ऑडियो/वीडियो पर आधारित होला आ इनपुट क्वालिटी भा भाषा
    //             के भिन्नता के कारण त्रुटि हो सके ला। कृपया आधिकारिक इस्तेमाल से पहिले सामग्री के सत्यापन करीं।
    //             कवनो विसंगति खातिर पंचायती राज मंत्रालय जिम्मेदार नइखे।`
    // },

    doi: {
        title: "डिस्क्लेमर",
        text: `एआई-जनरेट कीते गेदे संक्षेप अपलोड कीते गेदे ऑडियो/वीडियो पर आधारत न ते इनपुट गुणवत्ता जां
        भाशा च बदलाव दे कारण त्रुटियां हो सकदियां न। कृपा करियै आधिकारिक इस्तेमाल थमां पैह् ले
        सामग्री दी सत्यापन करो। पंचायती राज मंत्रालय कुसै बी विसंगति लेई जिम्मेदार नेईं ऐ।`
    },

    gom: {
        title: "डिस्क्लेमर",
        text: `AI- तयार केल्ले सारांश अपलोड केल्ल्या ऑडियो/व्हिडियोचेर आदारीत आसात आनी इनपुट गुणवत्तेक
        वा भाशेंतल्या बदलाक लागून चुको आसूं येतात. उपकार करून अधिकृत वापरा पयलीं सामुग्री
        तपासात. कसल्याच विसंगती खातीर पंचायती राज मंत्रालय जापसालदार ना.`
    },

    kn: {
        title: "ಡಿಸ್ಕ್ಲೈಮರ್",
        text: `AI- ರಚಿತವಾದ ಸಾರಾಂಶಗಳು ಅಪ್‌ಲೋಡ್ ಮಾಡಲಾದ ಆಡಿಯೋ/ವೀಡಿಯೊವನ್ನು ಆಧರಿಸಿವೆ ಮತ್ತು
        ಇನ್‌ಪುಟ್ ಗುಣಮಟ್ಟ ಅಥವಾ ಭಾಷಾ ವ್ಯತ್ಯಾಸದಿಂದಾಗಿ ದೋಷಗಳನ್ನು ಹೊಂದಿರಬಹುದು. ಅಧಿಕೃತ ಬಳಕೆಗೆ
        ಮೊದಲು ದಯವಿಟ್ಟು ವಿಷಯವನ್ನು ಪರಿಶೀಲಿಸಿ. ಯಾವುದೇ ವ್ಯತ್ಯಾಸಗಳಿಗೆ ಪಂಚಾಯತ್ ರಾಜ್ ಸಚಿವಾಲಯವು
        ಜವಾಬ್ದಾರನಾಗಿರುವುದಿಲ್ಲ.`
    },

    gu: {
        title: "ડિસ્ક્લેમર",
        text: `એઆઈ-જનરેટેડ સારાંશ અપલોડ કરેલા ઓડિયો/વિડિયો પર આધારિત છે અને ઇનપુટ ગુણવત્તા અથવા ભાષાના
        ભિન્નતાને કારણે તેમાં ભૂલો હોઈ શકે છે. કૃપા કરીને સત્તાવાર ઉપયોગ કરતા પહેલા સામગ્રીની ચકાસણી કરો.
        પંચાયતી રાજ મંત્રાલય કોઈપણ વિસંગતતા માટે જવાબદાર નથી.`
    },

    ml: {
        title: "ഡിസ്ക്ലെയിമർ",
        text: `AI- സൃഷ്ടിച്ച സംഗ്രഹങ്ങൾ അപ്‌ലോഡ് ചെയ്‌ത
        ഓഡിയോ/വീഡിയോയെ അടിസ്ഥാനമാക്കിയുള്ളതാണ്, ഇൻപുട്ട്
        ഗുണനിലവാരമോ ഭാഷാ വ്യതിയാനമോ കാരണം പിശകുകൾ
        അടങ്ങിയിരിക്കാം. ഔദ്യോഗിക ഉപയോഗത്തിന് മുമ്പ് ഉള്ളടക്കം
        പരിശോധിക്കുക. ഏതെങ്കിലും പൊരുത്തക്കേടുകൾക്ക്
        പഞ്ചായത്തീരാജ് മന്ത്രാലയം ബാധ്യസ്ഥനല്ല.`
    },

    mr: {
        title: "डिस्क्लेमर",
        text: `एआय-व्युत्पन्न सारांश अपलोड केलेल्या ऑडिओ/व्हिडिओवर आधारित आहेत आणि इनपुट गुणवत्तेमुळे
        किंवा भाषेतील फरकामुळे त्यात त्रुटी असू शकतात. अधिकृत वापर करण्यापूर्वी कृपया सामग्रीची
        पडताळणी करा. कोणत्याही विसंगतीसाठी पंचायती राज मंत्रालय जबाबदार नाही.`
    },

    ne: {
        title: "डिस्क्लेमर",
        text: `एआई-उत्पन्न सारांशहरू अपलोड गरिएको अडियो/भिडियोमा आधारित छन् र इनपुट गुणस्तर वा
        भाषा भिन्नताका कारण त्रुटिहरू हुन सक्छन्। आधिकारिक प्रयोग गर्नु अघि कृपया सामग्री प्रमाणित
        गर्नुहोस्। कुनै पनि विसंगतिको लागि पंचायती राज मन्त्रालय उत्तरदायी छैन।`
    },

    or: {
        title: "ଡିସ୍କ୍ଲେମର",
        text: `ଏଆଇ-ଜେନେରେଟେଡ୍ ସାରାଂଶଗୁଡ଼ିକ ଅପଲୋଡ୍ ହୋଇଥିବା ଅଡିଓ/ଭିଡିଓ ଉପରେ ଆଧାରିତ ଏବଂ ଇନପୁଟ୍
        ଗୁଣବତ୍ତା କିମ୍ବା ଭାଷା ପରିବର୍ତ୍ତନ ଯୋଗୁଁ ଏଥିରେ ତ୍ରୁଟି ଥାଇପାରେ। ଦୟାକରି ସରକାରୀ ବ୍ୟବହାର ପୂର୍ବରୁ
        ବିଷୟବସ୍ତୁ ଯାଞ୍ଚ କରନ୍ତୁ। ପଞ୍ଚାୟତି ରାଜ ମନ୍ତ୍ରଣାଳୟ କୌଣସି ବିଚ୍ଛିନ୍ନତା ପାଇଁ ଦାୟୀ ନୁହେଁ।`
    },

    pa: {
        title: "ਡਿਸਕਲੇਮਰ",
        text: `ਏਆਈ-ਤਿਆਰ ਕੀਤੇ ਗਏ ਸਾਰਾਂਸ਼ ਅੱਪਲੋਡ ਕੀਤੇ ਆਡੀਓ/ਵੀਡੀਓ &#39;ਤੇ ਅਧਾਰਤ ਹਨ ਅਤੇ ਇਨਪੁਟ ਗੁਣਵੱਤਾ ਜਾਂ ਭਾਸ਼ਾ
        ਭਿੰਨਤਾ ਦੇ ਕਾਰਨ ਗਲਤੀਆਂ ਹੋ ਸਕਦੀਆਂ ਹਨ। ਕਿਰਪਾ ਕਰਕੇ ਅਧਿਕਾਰਤ ਵਰਤੋਂ ਤੋਂ ਪਹਿਲਾਂ ਸਮੱਗਰੀ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ।
        ਪੰਚਾਇਤੀ ਰਾਜ ਮੰਤਰਾਲਾ ਕਿਸੇ ਵੀ ਅੰਤਰ ਲਈ ਜ਼ਿੰਮੇਵਾਰ ਨਹੀਂ ਹੈ।`
    },

    sa: {
        title: "डिस्क्लेमर",
        text: `एआइ-जनितसारांशाः अपलोड् कृते श्रव्य/वीडियो आधारिताः सन्ति तथा च निवेशगुणवत्तायाः अथवा
        भाषाविविधतायाः कारणेन त्रुटयः भवितुम् अर्हन्ति । कृपया आधिकारिकप्रयोगात् पूर्वं सामग्रीं
        सत्यापयन्तु। पंचायतीराजमन्त्रालयः कस्यापि विसंगतिस्य उत्तरदायी नास्ति।`
    },

    sat: {
        title: "ᱰᱤᱥᱠᱞᱮᱢᱟᱨ",
        text: `AI ᱛᱮ ᱥᱤᱨᱡᱟᱣ ᱟᱠᱟᱱ ᱥᱟᱨᱠᱟᱛᱷᱟ ᱫᱚ ᱟᱯᱞᱳᱰ ᱟᱠᱟᱱ ᱚᱰᱤᱭᱚ/ᱵᱷᱤᱰᱤᱭᱳ ᱨᱮ
        ᱴᱮᱸᱦᱟᱱᱰ ᱟᱠᱟᱱᱟ ᱟᱨ ᱤᱱᱯᱩᱴ ᱜᱩᱱ ᱥᱮ ᱯᱟᱹᱨᱥᱤ ᱵᱷᱮᱜᱟᱨ ᱠᱷᱟᱹᱛᱤᱨ ᱛᱮ ᱦᱩᱰᱟᱹᱜ ᱦᱩᱭ
        ᱫᱟᱲᱮᱭᱟᱜᱼᱟ᱾ ᱫᱟᱭᱟ ᱠᱟᱛᱮ ᱚᱯᱷᱤᱥᱤᱭᱟᱞ ᱵᱮᱵᱷᱟᱨ ᱢᱟᱲᱟᱝ ᱨᱮ ᱡᱤᱱᱤᱥ ᱠᱚ ᱯᱩᱥᱴᱟᱹᱣ
        ᱢᱮ᱾ ᱯᱟᱱᱪᱟᱭᱛᱤ ᱨᱟᱡᱽ ᱢᱟᱱᱛᱨᱟᱞᱟᱭ ᱫᱚ ᱡᱟᱦᱟᱱ ᱵᱷᱮᱜᱟᱨ ᱞᱟᱹᱜᱤᱫ ᱫᱟᱭᱤᱠ ᱵᱟᱝ
        ᱠᱟᱱᱟ ᱾`
    },

    ur: {
        title: "ڈسکلیمر",
        text: `AI سے تیار کردہ خلاصے اپ لوڈ کردہ آڈیو/ویڈیو پر مبنی ہیں اور ان پٹ کے معیار یا زبان کے تغیر کی وجہ
        سے اس میں غلطیاں ہو سکتی ہیں۔ براہ کرم سرکاری استعمال سے پہلے مواد کی تصدیق کریں۔ پنچایتی راج
        کی وزارت کسی بھی تضاد کے لیے ذمہ دار نہیں ہے۔`
    },

    te: {
        title: "డిస్క్లైమర్",
        text: `AI రూపొందించిన సారాంశాలు అప్‌లోడ్ చేయబడిన ఆడియో/వీడియో
        ఆధారంగా ఉంటాయి మరియు ఇన్‌పుట్ నాణ్యత లేదా భాష వైవిధ్యం
        కారణంగా లోపాలు ఉండవచ్చు. అధికారిక ఉపయోగం ముందు దయచేసి
        కంటెంట్‌ను ధృవీకరించండి. ఏవైనా వ్యత్యాసాలకు పంచాయతీ రాజ్
        మంత్రిత్వ శాఖ బాధ్యత వహించదు.`
    },

    ta: {
        title: "டிஸ்க்ளைமர்",
        text: `AI-உருவாக்கிய சுருக்கங்கள் பதிவேற்றப்பட்ட ஆடியோ/வீடியோவை
        அடிப்படையாகக் கொண்டவை மற்றும் உள்ளீட்டு தரம் அல்லது மொழி மாறுபாடு
        காரணமாக பிழைகள் இருக்கலாம். அதிகாரப்பூர்வ பயன்பாட்டிற்கு முன்
        உள்ளடக்கத்தைச் சரிபார்க்கவும். எந்தவொரு முரண்பாடுகளுக்கும் பஞ்சாயத்து
        ராஜ் அமைச்சகம் பொறுப்பல்ல.`
    },

    sd: {
        title: "ڊسڪليمر",
        text: `AI پاران تيار ڪيل خلاصا اپلوڊ ڪيل آڊيو/ويڊيو تي ٻڌل آهن ۽ ان پٽ جي معيار يا ٻولي جي فرق جي ڪري
        غلطيون ٿي سگهن ٿيون. مهرباني ڪري سرڪاري استعمال کان اڳ مواد جي تصديق ڪريو. پنچايت راج جي
        وزارت ڪنهن به تضاد لاءِ ذميوار نه آهي.`
    },

    mai: {
        title: "डिस्क्लेमर",
        text: `एआई द्वारा उत्पन्न सारांश अपलोड कैल गेल ऑडियो/वीडियो पर आधारित छै आ इनपुट गुणवत्ता या
        भाषा भिन्नता कें कारण त्रुटि भ सकय छै। आधिकारिक उपयोग सँ पहिने सामग्री सत्यापित करू। कोनो
        तरहक विसंगतिक लेल पंचायती राज मंत्रालय उत्तरदायी नहि अछि।`
    },

    as: {
        title: "ডিসক্লেইমাৰ",
        text: `AI-উৎপন্ন সাৰাংশসমূহ আপলোড কৰা অডিঅ&#39;/ভিডিঅ&#39;ৰ ওপৰত ভিত্তি কৰি কৰা হয় আৰু
        ইনপুট মান বা ভাষাৰ তাৰতম্যৰ বাবে ভুল থাকিব পাৰে। আনুষ্ঠানিক ব্যৱহাৰৰ পূৰ্বে অনুগ্ৰহ
        কৰি বিষয়বস্তু পৰীক্ষা কৰক। কোনো ধৰণৰ অমিলৰ বাবে পঞ্চায়তীৰাজ মন্ত্ৰালয় দায়ী
        নহয়।`
    },

    mni: {
        title: "ꯗꯤꯁꯀ꯭ꯂꯦꯃꯔ",
        text: `ꯑꯦ. ꯑꯥꯏ. ꯅ ꯄꯨꯊꯣꯛꯄ ꯁꯝꯃꯥꯔꯤꯁꯤꯡ ꯑꯁꯤ ꯊꯥꯖꯤꯟꯈ ꯭ ꯔꯕ ꯑꯣꯗꯤꯑꯣ/ꯚꯤꯗꯤꯑꯣꯗ ꯌꯨꯝꯐꯝ
        ꯑꯣꯏꯕꯅꯤ ꯑꯃꯁꯨꯡ ꯏꯟꯄꯨꯠꯀꯤ ꯃꯒꯨꯟ ꯅꯠꯇ ꯭ ꯔꯒ ꯂꯣꯜꯒꯤ ꯈꯦꯠꯅꯔꯛꯄꯅ ꯃꯔꯝ ꯑꯣꯏꯗꯨꯅ
        ꯑꯁꯣꯏꯕꯁꯤꯡ ꯌꯥꯎꯕ ꯌꯥꯏ ꯫ ꯆꯥꯟꯕꯤꯗꯨꯅ ꯑꯣꯐꯤꯁ ꯭ ꯌꯦꯜ ꯑꯣꯏꯅ ꯁꯤꯖꯤꯟꯅꯗ ꯭ ꯔꯤꯉꯩ ꯃꯃꯥꯡꯗ ꯃꯆꯥꯛ
        ꯑꯗꯨ ꯆꯦꯛꯁꯤꯟꯕꯤꯌꯨ ꯫ ꯄꯟꯆꯥꯌꯇꯤ ꯔꯥꯖ ꯃꯟꯇ ꯭ ꯔꯥꯂꯌ ꯑꯁꯤ ꯈꯦꯠꯅꯕ ꯑꯃꯠꯇꯒꯤ ꯃꯔꯝ ꯑꯣꯏꯗꯦ
        ꯫`
    },

    brx: {
        title: "डिस्क्लेमर",
        text: `ए. आइ. जों दिहुनजानाय सुंद &#39;लिरथाइफोरा आपल&#39; ड खालामनाय अडिय &#39;/वीडिय&#39; नि सायाव बिथा
        खालामनाय आरो बेयाव इनपुट गुन एबा राव सोलायनायनि थाखाय गोरोन्थिफोर थानो हागौ। मावख
        &#39;आरि बाहायनायनि सिगां अन्नानै आयदाफोरखौ फोरमान खालाम। पञ्चाय़ति राज मनत्रिआ
        जायखिजाया बेले-बेजेनि थाखाय बिबान गोनां नङा।`
    },

    ks: {
        title: "دعوی",
        text: `اے آٮٔی یس سۭتۍ پٲدٕ کرنہٕ آمٕتۍ خلاصہٕ چھ اپ لوڈ کرنہٕ آمٕتۍ آڈیو/ویڈیو پؠٹھ مبنی تہٕ اتھ منٛز ہیٚکہ ان پٹ کوالٹی یا زبٲنۍ منٛز تغیر کہ وجہ سۭتۍ غلطی ٲستھ۔ مہربٲنی کٔرتھ کٔرو سرکٲرۍ استعمال برونٹھ موادچ تصدیق۔ پنچایتی راج وزارت کینٛہہ بی فرقس باپت ذمہ دار نئ۔`
    }
};


export const en_translate_language_map = {
    'bn': 'Bengali',
    'gu': 'Gujarati',
    'hi': 'Hindi',
    'kn': 'Kannada',
    'ml': 'Malayalam',
    'mr': 'Marathi',
    'pa': 'Punjabi',
    "sa": "Sanskrit",
    'or': 'Odia',
    'ta': 'Tamil',
    'te': 'Telugu',
    'ur': 'Urdu',
    "ks": "Kashmiri",
    "as": "Assamese",
    "gom": "Konkani",
    "doi": "Dogri",
    "brx": "Bodo",
    "mai": "Maithili",
    "mni": "Manipuri",
    "ne": "Nepali",
    "sat": "Santhali",
    "sd": "Sindhi",
    // "bho": "Bhojpuri"
}

